<template>

<app-input :label="(value.length) ? false : label">

    <div class="section-empty" v-if="!value.length" v-on:click="onEmptyClick">Click to add section</div>

    <div class="section-list" v-if="value.length">

        <transition-group name="flip-list">

        <template v-for="(section, index) in value">

            <com-insert v-on:click="onInsertClick(index)" v-if="index === 0 && isAdmin" :key="section.id + 'pre'" />

            <com-item v-model="value[index]" :is-admin="isAdmin" :item="section" :key="section.id" :is-first="index === 0" :is-last="index === value.length - 1" 
                v-on:edit="onSectionEdit" 
                v-on:up="onSectionUp" 
                v-on:down="onSectionDown" 
                v-on:remove="onSectionRemove" 
                v-on:show="onSectionShow" 
                v-on:hide="onSectionHide" 
            />

            <com-insert v-on:click="onInsertClick(index + 1)" :key="section.id+'post'" v-if="isAdmin" />

        </template>

        </transition-group>

    </div>

    <com-edit v-if="is.section" :is-admin="isAdmin" :item="is.section" v-on:close="onSectionClose" v-on:confirm="onSectionConfirm" />

</app-input>

</template>

<script>

import comInsert from './section/Insert'
import comItem from './section/Item'
import comEdit from './section/Edit'

export default {

    props: ['label', 'value', 'isAdmin'],

    components: {
        'com-insert': comInsert,
        'com-item': comItem,
        'com-edit': comEdit
    },

    data: function() {

        return {
            is: {
                section: false
            },
            insertPoint: false
        }

    },

    methods: {

        onEmptyClick: function() {

            this.insertPoint = false
            this.is.section = true

        },

        onInsertClick: function(index) {

            this.insertPoint = index
            this.is.section = true

        },

        onSectionClose: function() {

            this.is.section = false

        },

        onSectionEdit: function(value) {

            this.$vueset(this.is, 'section', value)

        },

        onSectionRemove: function(value) {

            var sections = this.$util.clone(this.value)

            this.$util.collection.remove(sections, value)

            this.$emit('input', sections)

        },

        onSectionShow: function(value) {

            var sections = this.$util.clone(this.value)

            value.enabled = 1

            this.$util.collection.update(sections, value)

            this.$emit('input', sections)

        },

        onSectionHide: function(value) {

            var sections = this.$util.clone(this.value)

            value.enabled = 0

            this.$util.collection.update(sections, value)

            this.$emit('input', sections)

        },

        onSectionUp: function(value) {

            var sections = this.$util.clone(this.value)

            this.$util.collection.up(sections, value)

            this.$emit('input', sections)

        },

        onSectionDown: function(value) {

            var sections = this.$util.clone(this.value)

            this.$util.collection.down(sections, value)

            this.$emit('input', sections)

        },

        onSectionConfirm: function(value) {

            var sections = this.$util.clone(this.value)

            if(!value.id) {
                
                value.id = this.$util.generateKey(16)

                this.$util.collection.add(sections, value, this.insertPoint)

            } else {

                this.$util.collection.update(sections, value)

            }

            this.$emit('input', sections)

            this.is.section = false

        }

    }

}

</script>

<style scoped>

.flip-list-move {
    transition: transform 100ms linear;
}

.section-empty {
	border: 2px solid #eee;
	border-radius: 10px;
	text-align: center;
	line-height: 120px;
	color: #999;
	font-size: 16px;
	cursor: pointer;
	font-weight: 500;
}

.section-empty:hover {
	border-color: #4082d3;
	color: #4082d3;
}

.section-list {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 10px;
}

</style>
